/**
 * Query Keys Factory
 * Centralized query key management for type safety and consistency
 * Note: queryClient has been moved to src/config/queryClient.js for app-wide usage
 */
export const queryKeys = {
  // Leads board queries
  leads: {
    all: ['leads'],
    board: (leadStages) => ['leads', 'board', leadStages],
    column: (columnId, page) => ['leads', 'column', columnId, page],
    infiniteColumn: (columnId) => ['leads', 'column-infinite', columnId],
  },
  // Practice areas
  practiceAreas: {
    all: ['practice-areas'],
    list: () => ['practice-areas', 'list'],
  },
  // Lead stages
  leadStages: {
    all: ['lead-stages'],
    list: (practice_area, show_unassigned_pa_column) => ['lead-stages', 'list', practice_area, show_unassigned_pa_column],
  },
  // Users
  users: {
    all: ['users'],
    list: (status) => ['users', 'list', status],
  },
};
